import { ArrowRight, FileText } from "lucide-react";

const articles = [
  {
    title: "5 Legal Checks Every Diaspora Investor Must Complete Before Buying Property in Nigeria",
    description: "A practical guide explaining the essential legal due diligence steps investors should complete before purchasing property."
  },
  {
    title: "Understanding Land Title Verification in Nigeria",
    description: "An overview of how land titles are verified and why proper legal due diligence is essential before any property acquisition."
  },
  {
    title: "How Diaspora Investors Can Safely Acquire Property in Nigeria",
    description: "Key legal considerations for investors purchasing property remotely from abroad."
  }
];

export const LegalInsightsSection = () => {
  return (
    <section 
      className="py-16 md:py-24 lg:py-32 bg-[#FAFAF9] relative overflow-hidden"
      data-testid="legal-insights-section"
    >
      {/* Decorative top line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      
      <div className="relative z-10 max-w-6xl mx-auto px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
            Resources
          </span>
          <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-[#0A0A0B] mt-4 md:mt-6 leading-tight">
            Investor Legal
            <span className="block text-[#D4AF37] italic">Insights</span>
          </h2>
          <div className="w-16 md:w-20 h-px bg-[#D4AF37] mx-auto mt-6 md:mt-8" />
          
          {/* Introduction text */}
          <p className="max-w-3xl mx-auto mt-8 md:mt-10 text-[#0A0A0B]/60 text-sm md:text-base lg:text-lg leading-relaxed">
            Our firm regularly publishes practical legal guidance for investors seeking to 
            acquire property in Nigeria safely and securely. These insights are designed to help 
            both local and diaspora investors understand the legal risks and protections involved 
            in property transactions.
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article, index) => (
            <article 
              key={index} 
              className="group bg-white border border-[#0A0A0B]/10 hover:border-[#D4AF37]/50 hover:shadow-lg transition-all duration-300 flex flex-col"
              data-testid={`insight-article-${index}`}
            >
              {/* Article header bar */}
              <div className="h-2 bg-[#0A0A0B] group-hover:bg-[#D4AF37] transition-colors duration-300" />
              
              <div className="p-6 md:p-8 flex flex-col flex-1">
                {/* Icon */}
                <div className="w-12 h-12 border border-[#D4AF37]/30 flex items-center justify-center mb-5 group-hover:border-[#D4AF37] group-hover:bg-[#D4AF37]/10 transition-all duration-300">
                  <FileText className="w-5 h-5 text-[#D4AF37]" />
                </div>
                
                {/* Title */}
                <h3 className="font-['Playfair_Display'] text-lg md:text-xl text-[#0A0A0B] mb-3 md:mb-4 leading-snug group-hover:text-[#D4AF37] transition-colors duration-300">
                  {article.title}
                </h3>
                
                {/* Description */}
                <p className="text-[#0A0A0B]/60 text-sm md:text-base leading-relaxed flex-1">
                  {article.description}
                </p>
                
                {/* Read more link */}
                <div className="mt-5 md:mt-6 pt-5 border-t border-[#0A0A0B]/10">
                  <span className="inline-flex items-center gap-2 text-[#D4AF37] text-sm font-semibold tracking-wide group-hover:gap-3 transition-all duration-300">
                    Read Article
                    <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
      
      {/* Decorative bottom line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
    </section>
  );
};
